export default __webpack_public_path__ + "static/media/bg-login.4eecfa23.png";